import { isEmpty } from 'lodash';
import React from 'react';
import { TransferSearchFilters } from '../const/types';

const LinkToTransferSearch: React.FC<
  React.PropsWithChildren<{ filters: TransferSearchFilters, maxWidth?: number }>
> = ({ filters, children, maxWidth }) => {
  if (isEmpty(filters)) {
    return null;
  }

  const queryParams = new URLSearchParams(filters as Record<string, string>);

  return (
    <a href={`/reco/transfer-search?${queryParams.toString()}`} target="_blank" style={{
      ...(maxWidth && {
        maxWidth,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block'
      })
    }}>
      {children}
    </a>
  );
};

export default LinkToTransferSearch;
